'use client'

import { useTranslations } from 'next-intl'
import { ComponentType, SVGProps } from 'react'

import {
  HighRentalIncome,
  FastVacancyResolution,
  ConvenientManagement,
  SafeRental,
} from '@/shared/asset'
import { useRouter } from '@/shared/i18n'
import { SignUpIntro } from '@/widgets/sign-up'

export const SignUpHostIntro = () => {
  const router = useRouter()

  const t = useTranslations('signup_landlord_landing')

  const content: {
    title: string
    description: string
    image: ComponentType<SVGProps<SVGSVGElement>>
  }[] = [
    {
      title: t('high_rental_income_title'),
      description: t('high_rental_income_description'),
      image: HighRentalIncome,
    },
    {
      title: t('fast_vacancy_resolution_title'),
      description: t('fast_vacancy_resolution_description'),
      image: FastVacancyResolution,
    },
    {
      title: t('easy_management_title'),
      description: t('easy_management_description'),
      image: ConvenientManagement,
    },
    {
      title: t('safe_rental_title'),
      description: t('safe_rental_description'),
      image: SafeRental,
    },
  ]

  const handleButtonClick = () => {
    router.push('/sign-up/host?step=terms')
  }

  return (
    <SignUpIntro
      title={t('title')}
      content={content}
      buttonText={t('button.start_sign_up')}
      onButtonClick={handleButtonClick}
    />
  )
}
